import React, { createContext, ReactNode } from 'react';

import { defaultCurrency } from '@zapier/currency';

import {
  Account,
  Currency,
  MemberRole,
  Plan,
  TrialType,
} from '@zapier/upsells/src/types';

type Props = {
  children: ReactNode;
  upgradeModalData: UpgradeModalContextProps;
};

export type UpgradeModalContextProps = {
  account: Account | undefined;
  accountCurrency: Currency;
  activeTrialType: TrialType | undefined;
  autoUpgradeToPlan: Plan | null | undefined;
  billingPeriodEndDate: string | null | undefined;
  billingPeriodStartDate: string | null | undefined;
  canExtendTrial: boolean;
  currentUserRole: MemberRole;
  destinationPlan: Plan | null | undefined;
  enabledTrialExtensions: (string | null)[] | null;
  error: string | undefined;
  extendTrial: any | (() => void);
  isAutoUpgradeEnabled: boolean;
  isLoading: boolean;
  isPaymentMethodProvided: boolean;
  taskBufferOverride: number;
  tasksRemaining: number;
};

export const defaultUpgradeModalContext = {
  account: undefined,
  accountCurrency: defaultCurrency,
  activeTrialType: undefined,
  autoUpgradeToPlan: undefined,
  billingPeriodEndDate: null,
  billingPeriodStartDate: null,
  canExtendTrial: false,
  currentUserRole: 'member' as MemberRole,
  destinationPlan: undefined,
  enabledTrialExtensions: [],
  error: undefined,
  extendTrial: () => {},
  isAutoUpgradeEnabled: false,
  isLoading: false,
  isPaymentMethodProvided: false,
  taskBufferOverride: 0,
  tasksRemaining: 0,
};

export const UpgradeModalContext = createContext<UpgradeModalContextProps>(
  defaultUpgradeModalContext
);

export const UpgradeModalProvider = ({ children, upgradeModalData }: Props) => (
  <UpgradeModalContext.Provider value={upgradeModalData}>
    {children}
  </UpgradeModalContext.Provider>
);
